var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { "justify-end": "" } },
    [
      _c(
        "v-btn",
        {
          staticClass: "mb-2",
          attrs: { slot: "activator", outline: "", color: "primary" },
          on: { click: _vm.open },
          slot: "activator"
        },
        [
          _c("v-icon", { attrs: { dark: "", left: "" } }, [_vm._v("note_add")]),
          _vm._v("New Item\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "1500px", scrollable: "" },
          model: {
            value: _vm.localDialog,
            callback: function($$v) {
              _vm.localDialog = $$v
            },
            expression: "localDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("span", { staticClass: "headline" }, [
                  _vm._v(_vm._s(_vm.formTitle))
                ])
              ]),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    { attrs: { fluid: "" } },
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          attrs: { "lazy-validation": "" },
                          model: {
                            value: _vm.valid,
                            callback: function($$v) {
                              _vm.valid = $$v
                            },
                            expression: "valid"
                          }
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                [
                                  _c("image-uploader", {
                                    attrs: {
                                      constImage: _vm.local.image,
                                      dialog: _vm.dialog
                                    },
                                    on: { image: _vm.assignImage }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Name",
                                      rules: _vm.generalRules,
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.local.name,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "name", $$v)
                                      },
                                      expression: "local.name"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Prefab name",
                                      rules: _vm.generalRules,
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.local.prefabName,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "prefabName", $$v)
                                      },
                                      expression: "local.prefabName"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: { label: "Service (Optional)" },
                                    model: {
                                      value: _vm.local.service,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "service", $$v)
                                      },
                                      expression: "local.service"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-textarea", {
                                    attrs: { label: "Description (Optional)" },
                                    model: {
                                      value: _vm.local.description,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "description", $$v)
                                      },
                                      expression: "local.description"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.effectTypes,
                                      label: "Select Effect Type",
                                      rules: _vm.generalRules,
                                      required: "",
                                      chips: "",
                                      "persistent-hint": ""
                                    },
                                    model: {
                                      value: _vm.local.effectType,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "effectType", $$v)
                                      },
                                      expression: "local.effectType"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("br")
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c("v-divider", { attrs: { vertical: "" } }),
                              _vm._v(" "),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                [
                                  _c("popover", { attrs: { always: true } }, [
                                    _c("h3", [_vm._v("Position of Origin")])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs3: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Dimension X",
                                              type: "number"
                                            },
                                            model: {
                                              value:
                                                _vm.local.positionOfOrigin.X,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.local.positionOfOrigin,
                                                  "X",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "local.positionOfOrigin.X"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs3: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Dimension Y",
                                              type: "number"
                                            },
                                            model: {
                                              value:
                                                _vm.local.positionOfOrigin.Y,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.local.positionOfOrigin,
                                                  "Y",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "local.positionOfOrigin.Y"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs3: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Dimension Z",
                                              type: "number"
                                            },
                                            model: {
                                              value:
                                                _vm.local.positionOfOrigin.Z,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.local.positionOfOrigin,
                                                  "Z",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "local.positionOfOrigin.Z"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("popover", { attrs: { always: true } }, [
                                    _c("h3", [_vm._v("Rotation of Origin")])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs3: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Dimension X",
                                              type: "number"
                                            },
                                            model: {
                                              value:
                                                _vm.local.rotationOfOrigin.X,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.local.rotationOfOrigin,
                                                  "X",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "local.rotationOfOrigin.X"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs3: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Dimension Y",
                                              type: "number"
                                            },
                                            model: {
                                              value:
                                                _vm.local.rotationOfOrigin.Y,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.local.rotationOfOrigin,
                                                  "Y",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "local.rotationOfOrigin.Y"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs3: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Dimension Z",
                                              type: "number"
                                            },
                                            model: {
                                              value:
                                                _vm.local.rotationOfOrigin.Z,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.local.rotationOfOrigin,
                                                  "Z",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "local.rotationOfOrigin.Z"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("popover", { attrs: { always: true } }, [
                                    _c("h3", [_vm._v("Scale of Origin")])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs3: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Dimension X",
                                              type: "number"
                                            },
                                            model: {
                                              value: _vm.local.scaleOfOrigin.X,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.local.scaleOfOrigin,
                                                  "X",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "local.scaleOfOrigin.X"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs3: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Dimension Y",
                                              type: "number"
                                            },
                                            model: {
                                              value: _vm.local.scaleOfOrigin.Y,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.local.scaleOfOrigin,
                                                  "Y",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "local.scaleOfOrigin.Y"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs3: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Dimension Z",
                                              type: "number"
                                            },
                                            model: {
                                              value: _vm.local.scaleOfOrigin.Z,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.local.scaleOfOrigin,
                                                  "Z",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "local.scaleOfOrigin.Z"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Duration (sec)",
                                      type: "number"
                                    },
                                    model: {
                                      value: _vm.local.duration,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "duration", $$v)
                                      },
                                      expression: "local.duration"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.identifiableSurfaces,
                                      label: "Select Identifiable Surface",
                                      chips: "",
                                      "persistent-hint": ""
                                    },
                                    model: {
                                      value: _vm.local.identifiableSurface,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.local,
                                          "identifiableSurface",
                                          $$v
                                        )
                                      },
                                      expression: "local.identifiableSurface"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: { label: "Movement Element" },
                                    model: {
                                      value: _vm.local.movementElement,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.local,
                                          "movementElement",
                                          $$v
                                        )
                                      },
                                      expression: "local.movementElement"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                [
                                  _c("h3", [_vm._v("Attachments")]),
                                  _vm._v(" "),
                                  _c("h3", [_vm._v("Allowed Sound")]),
                                  _vm._v(" "),
                                  _c(
                                    "v-radio-group",
                                    {
                                      attrs: { row: "" },
                                      model: {
                                        value: _vm.local.allow_sound,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.local,
                                            "allow_sound",
                                            $$v
                                          )
                                        },
                                        expression: "local.allow_sound"
                                      }
                                    },
                                    [
                                      _c("v-radio", {
                                        attrs: { label: "Yes", value: true }
                                      }),
                                      _vm._v(" "),
                                      _c("v-radio", {
                                        attrs: { label: "No", value: false }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-checkbox", {
                                    attrs: { label: "Loops" },
                                    model: {
                                      value: _vm.local.loop,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "loop", $$v)
                                      },
                                      expression: "local.loop"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", outline: "" },
                      on: { click: _vm.close }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _vm.showSaveButton
                    ? _c(
                        "v-btn",
                        {
                          attrs: { color: "primary" },
                          on: { click: _vm.save }
                        },
                        [
                          this.saving
                            ? _c(
                                "v-flex",
                                [
                                  _c("v-progress-circular", {
                                    attrs: {
                                      indeterminate: "",
                                      color: "primary"
                                    }
                                  })
                                ],
                                1
                              )
                            : _c("v-flex", [_vm._v("Save")])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b410ebb", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b410ebb","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/add-new/addEffect.vue
// module id = null
// module chunks = 